module.exports = __webpack_public_path__ + "img/combo_screenshot_sdy2z7_c_scale,w_2202.85a7271d.png";